//服务账单定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 来源枚举
 */
class Source extends UltMeta {
    PROJECT = new Meta(1, "项目服务费", "01");
}

export const SOURCE = new Source();

/**
 * 核销状态枚举
 */
class VerificationState extends UltMeta {
    UN_VERIFICATION = new Meta(1, "未核销");
    VERIFICATION = new Meta(2, "已核销");
}

export const VERIFICATION_STATE = new VerificationState();
